module.exports = __webpack_public_path__ + "static/img/197_phase_function_Paper_PointsHejduk_Prediction.7d1214e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/197_phase_function_Paper_PointsHejduk_Prediction.png
// module id = oWyr
// module chunks = 0